var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5 8.91602V17.496C1.5 18.2917 1.81607 19.0547 2.37868 19.6173C2.94129 20.1799 3.70435 20.496 4.5 20.496H19.5C20.2956 20.496 21.0587 20.1799 21.6213 19.6173C22.1839 19.0547 22.5 18.2917 22.5 17.496V8.91602L13.572 14.409C13.0992 14.6999 12.5551 14.8539 12 14.8539C11.4449 14.8539 10.9008 14.6999 10.428 14.409L1.5 8.91602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5 7.15409V6.99609C22.5 6.20044 22.1839 5.43738 21.6213 4.87477C21.0587 4.31216 20.2956 3.99609 19.5 3.99609H4.5C3.70435 3.99609 2.94129 4.31216 2.37868 4.87477C1.81607 5.43738 1.5 6.20044 1.5 6.99609V7.15409L11.214 13.1321C11.4504 13.2775 11.7225 13.3545 12 13.3545C12.2775 13.3545 12.5496 13.2775 12.786 13.1321L22.5 7.15409Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.96d43d847da04f2b568e1089d2d15ca8.svg";
export { ForwardRef as ReactComponent };